import Vue from "vue";
import { mapGetters } from "vuex";
import { formatDateTime, stringHelper } from "@/components/mixins";

export default Vue.extend({
    name: "DlTable",
    components: {
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters([]),
    },
    data: () => ({
    }),
    props: {
        rows: {
            type: Array,
            default: () => [],
        },
        classes: {
            type: String,
            default: ""
        },
        dtClasses: {
            type: String,
            default: ""
        },
        ddClasses: {
            type: String,
            default: ""
        },
    },
    methods: {

    },
    watch: {
    },
});
